import React from "react";
import "./animatedEmotionEmotes.scss";
// Animated category
const AnimatedEmotionEmotesMustache = ({ rating }) => {
  const renderExpression = () => {
    switch (rating) {
      case 5:
        return (
          <div className="emoji-happy-face">
            <div className="cowBoyHat"></div>
            <div className="belt"></div>
            <div className="hairPiece"></div>
            <div className="emoji-happy-expression">
              <div className="emoji-eye emoji-eye-left"></div>
              <div className="emoji-eye emoji-eye-right"></div>
              <div className="moustache"></div>
            </div>
          </div>
        );
      case 4:
        return (
          <div className="emoji-smile-face">
            <div className="cowBoyHat"></div>
            <div className="belt"></div>
            <div className="hairPiece"></div>
            <div className="emoji-smile-expression-beard">
              <div className="emoji-eye emoji-eye-left"></div>
              <div className="emoji-eye emoji-eye-right"></div>
              <div className="moustache"></div>
            </div>
          </div>
        );
      case 3:
        return (
          <div className="emoji-sincere-face">
            <div className="cowBoyHat"></div>
            <div className="belt"></div>
            <div className="hairPiece"></div>
            <div className="emoji-sincere-expression-beard">
              <div className="emoji-eye emoji-eye-left"></div>
              <div className="emoji-eye emoji-eye-right"></div>
              <div className="moustache"></div>
              {/* Other facial features if needed */}
            </div>
          </div>
        );
      case 2:
        return (
          <div className="emoji-angry-face">
            <div className="cowBoyHat"></div>
            <div className="belt"></div>
            <div className="hairPiece"></div>
            <div className="emoji-angry-expression">
              <div className="emoji-eye angry emoji-eye-left"></div>
              <div className="emoji-eye angry emoji-eye-right"></div>
              <div className="moustache"></div>
              {/* Make sure this matches the class in your CSS */}
            </div>
          </div>
        );
      case 1:
        return (
          <div className="emoji-cry-face">
            <div className="cowBoyHat"></div>
            <div className="belt"></div>
            <div className="hairPiece"></div>
            <div className="emoji-cry-expression">
              <div className="emoji-cry-eye emoji-cry-eye-left">
                <div className="tear-stream"></div>{" "}
                {/* Water stream container */}
              </div>
              <div className="emoji-cry-eye emoji-cry-eye-right">
                <div className="tear-stream"></div>{" "}
              </div>
              <div className="moustache"></div>
            </div>
          </div>
        );
      case 0:
      default:
        return (
          <div className="emoji-default-face">
            <div className="cowBoyHat"></div>
            <div className="belt"></div>
            <div className="hairPiece"></div>
            <div className="emoji-default-expression">
              <div className="emoji-eye emoji-eye-left"></div>
              <div className="emoji-eye emoji-eye-right"></div>
              <div className="moustache"></div>
            </div>
          </div>
        );
      // or
      // return null; // Default to no face
    }
  };
  return (
    <div className={`emoji rank-${rating}`} key={`rating-${rating}`}>
      <div id={`rating-${rating}`}></div>
      {renderExpression()}
      {/* This element will receive the fade-in effect */}
    </div>
  );
};
export default AnimatedEmotionEmotesMustache;
